<template>
  <ul
    v-if="isPc"
    v-infinite-scroll="loadPotential"
    class="my-hidden-potential-container"
    :infinite-scroll-disabled="disabledLoadDate"
  >
    <li v-for="(item, index) in potentialList" class="potential-item" :key="index">
      <PotentialInfo isPc :potentialData="item"/>
    </li>
    <li v-if="potentialList.length < 1" class="tips">
      <p>{{ $t('personal.referrals.leads.message.leadNoData') }}</p>
    </li>
  </ul>
  <AnimationCardList
    v-else
    v-infinite-scroll="loadPotential"
    class="my-hidden-potential-container"
    dataKey="potential_id"
    empty-tip-i18n-key="personal.referrals.leads.message.leadNoData"
    :infinite-scroll-disabled="disabledLoadDate"
    :data="potentialList"
    :action-options="actionOptions"
    @action="onAction"
  >
    <template #default="{data}">
      <PotentialInfo :potentialData="data"/>
    </template>
  </AnimationCardList>
</template>

<script>
import { mapActions } from 'vuex'
import AnimationCardList, { ACTION_TYPE } from './components/animationCardList.vue'
import PotentialInfo from './components/potentialInfo.vue'
import { deviceType } from '@/utils/common'

export default {
  props: {

  },
  components: {
    AnimationCardList,
    PotentialInfo
  },
  data () {
    return {
      potentialList: [],
      disabledLoadDate: false,
      pageInfo: {
        pageSize: 20,
        currentPage: 1,
        total: 1
      }
    }
  },
  computed: {
    isPc () {
      return deviceType.isPc
    },
    actionOptions () {
      return {
        isShow: this.isShowAction,
        iconClass: this.getActionIconClass,
        tip: this.getActionTip,
        startColor: this.getActionStartColor,
        endColor: this.getActionEndColor,
        startFontSize: this.getActionStartFontSize,
        endFontSize: this.getActionEndFontSize
      }
    }
  },
  created () {

  },
  methods: {
    ...mapActions('personal', ['getMyHiddenPotentialCandidate', 'updateMyPotentialCandidateAttitude']),
    isShowAction (actionType, dataItem) {
      return actionType === ACTION_TYPE.RIGHT
    },
    getActionIconClass (actionType, dataItem) {
      return 'iconfont icona-MovetoPotential cancel-icon'
    },
    getActionTip (actionType, dataItem) {
      return this.$t('personal.referrals.leads.btn.moveAction.moveToPotential')
    },
    getActionStartColor (actionType, dataItem) {
      return '#15aa66'
    },
    getActionEndColor (actionType, dataItem) {
      return '#ffffff'
    },
    getActionStartFontSize (actionType, dataItem) {
      return 12
    },
    getActionEndFontSize (actionType, dataItem) {
      return 16
    },
    async initData () {
      this.getPotentialCandidateData(this.page)
    },
    async getPotentialCandidateData (page) {
      this.$eventBus.$emit('showLoading', true)
      this.disabledLoadDate = true
      try {
        const params = {
          page: this.pageInfo.currentPage,
          page_size: this.pageInfo.pageSize
        }
        if (!this.isPc) {
          params.company_id = this.$route.query.company_id
        }
        const resp = await this.getMyHiddenPotentialCandidate(params)
        if (resp) {
          this.pageInfo.total = resp.total_pages
          this.pageInfo.currentPage += 1
          if (this.pageInfo.total > 0 && this.pageInfo.currentPage < this.pageInfo.total) {
            this.disabledLoadDate = false
          }
          this.potentialList = this.potentialList.concat(resp.results)
        }
      } finally {
        this.$eventBus.$emit('showLoading', false)
      }
    },
    loadPotential () {
      this.getPotentialCandidateData(this.pageInfo.currentPage)
    },
    async onAction ({ actionType, dataItem, onFinished }) {
      this.$eventBus.$emit('showLoading', true)
      let resp = null
      this.disabledLoadDate = true
      try {
        this.pageInfo.currentPage = 1
        resp = await this.updateMyPotentialCandidateAttitude({
          data_type: 'hide',
          page: this.pageInfo.currentPage,
          page_size: this.pageInfo.pageSize,
          potential_id: dataItem.potential_id,
          company_id: this.$route.query.company_id,
          action: '3'
        })
      } finally {
        this.$eventBus.$emit('showLoading', false)
      }
      if (resp) {
        this.pageInfo.total = resp.total_pages
        if (this.pageInfo.total > 0 && this.pageInfo.currentPage < this.pageInfo.total) {
          this.disabledLoadDate = false
        }
        this.potentialList = resp.results
        await this.$nextTick()
        onFinished(actionType === ACTION_TYPE.RIGHT)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.my-hidden-potential-container {
  &.animation-card-list-container {
    ::v-deep {
      .card-action {
        .action-icon {
          .iconfont {
            font-size: inherit;
            color: #ffffff;
          }
        }

        .action-tip {
          color: #ffffff;
        }
      }
    }
  }
}
.page-pc {
  .my-hidden-potential-container {
    padding-bottom: 20px;

    .tips {
      text-align: center;
      padding-top: 20px;
    }
  }
}
</style>
